import {Transform} from "./Transform";

export default new class TransformHours extends Transform {

    transformToOpenHours(data) {
        if (!Array.isArray(data)) return [];
        return data.map(item => this.toOpenHour(item))
    }

    toOpenHour = (data) => {
        data = this.checkAndTakeJson(data)
        return {
            from: this.takeString(data, "from", "00:00:00"),
            to: this.takeString(data, "to", "23:59:59"),
            opened: this.takeString(data, "opened", false)
        }
    }

    transformToONewHourInfo = (data) => {
        if (!Array.isArray(data)) return [];
        return data.map(item => this.onHourInfo(item));
    }

    onHourInfo = (data) => {
        data = this.checkAndTakeJson(data);
        return {
            id: this.takeNumber(data, "id", -1),
            day: this.takeNumber(data, "day", 1),
            opened: this.takeBoolean(data, "opened", false),
            openHourFrom: this.takeString(data, "openHourFrom", null),
            openHourTo: this.takeString(data, "openHourTo", null),
            closeHourFrom: this.takeString(data, "closeHourFrom", null),
            closeHourTo: this.takeString(data, "closeHourTo", null),
            openHours: this.transformToOpenHours(this.checkAndTakeArray(data.openHours))
        }
    }

    transform = (data = null) => {
        data = this.checkAndTakeJson(data);
        return {
            pickupEnabled: this.takeBoolean(data, "pickupEnabled", false),
            deliveryEnabled: this.takeBoolean(data, "deliveryEnabled", false),
            today: this.takeNumber(data, "today", 1),
            pickup: this.transformToONewHourInfo(data.pickup),
            delivery: this.transformToONewHourInfo(data.delivery)
        }
    }

    get = (data = null) => {
        data = this.checkAndTakeJson(data);
        return {
            pickupEnabled: this.takeBoolean(data, "pickupEnabled", false),
            deliveryEnabled: this.takeBoolean(data, "deliveryEnabled", false),
            today: this.takeNumber(data, "today", 1),
            pickup: this.transformToONewHourInfo(data.pickup),
            delivery: this.transformToONewHourInfo(data.delivery),


            preOrderEnabled: this.takeBoolean(data, "preOrderEnabled", false),
            preOrderMaxDays: this.takeNumber(data, "preOrderMaxDays", 0),
            preOrderOnSameDay: this.takeBoolean(data, "preOrderOnSameDay", false),
            preOrderSubmissionDeadline: this.takeNumber(data, "preOrderSubmissionDeadline", 0),
            sameDayOrderEnabled: this.takeBoolean(data, "sameDayOrderEnabled", false),
        }
    }

}();
